import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import PageHeader from 'shared/components/page-header/page-header';
import PopUp from 'shared/components/pop-up/pop-up';
import Permission from 'shared/features/auth/authorization/enums/permission';
import usePermissionAuthorization from 'shared/features/auth/authorization/hooks/permission-authorization';

import { useTemporaryAccessContextProvider } from '../providers/temporary-access-provider';
import TemporaryAccessFilters from './temporary-access-filters';
import TemporaryAccessTable from './temporary-access-table.component';
import TemporaryUserDetailsPopup from './temporary-user-details-popup/temporary-user-details-popup.component';

import './temporary-access.component.scss';

const TemporaryAccess = (): ReactElement | null => {
  const { t } = useTranslation('temporaryAccess');
  const { hasPermission } = usePermissionAuthorization();

  const {
    openTemporaryUserDetailsPopup,
    temporaryUserDetailsPopupIsOpen,

    revokeTemporaryAccessIsLoading: revokeTemporaryUserIsLoading,

    closeRevokeTemporaryUserConfirmationPopup,
    revokeTemporaryUserConfirmationAction,
    revokeTemporaryUserConfirmationPopupIsOpen,
  } = useTemporaryAccessContextProvider();

  if (!hasPermission(Permission.ManageTemporaryAccess)) return null;
  return (
    <div className="temporary-users-container">
      <PageHeader
        title={t('pageHeaderTitle')}
        addBtnVisible
        onAdd={() => openTemporaryUserDetailsPopup('creation')}
        filterComponent={
          <div className="temporary-access-filter-component-container">
            <TemporaryAccessFilters />
          </div>
        }
      />
      <TemporaryAccessTable />
      {temporaryUserDetailsPopupIsOpen && <TemporaryUserDetailsPopup />}
      <PopUp
        isOpen={revokeTemporaryUserConfirmationPopupIsOpen}
        title={t('revokeTemporaryUserConfirmation.title')}
        body={t('revokeTemporaryUserConfirmation.body')}
        primaryButtonText={t('revokeTemporaryUserConfirmation.confirmButton')}
        secondaryButtonText={t('revokeTemporaryUserConfirmation.cancelButton')}
        handleOnClose={closeRevokeTemporaryUserConfirmationPopup}
        secondaryButtonAction={closeRevokeTemporaryUserConfirmationPopup}
        primaryButtonAction={() => revokeTemporaryUserConfirmationAction?.()}
        isLoadingPrimaryAction={revokeTemporaryUserIsLoading}
      />
    </div>
  );
};

export default TemporaryAccess;
